import { useCallback, useRef, useState } from 'react';
import { trackQuizModalImpression } from '../QuizPrompt/track';
const IMPRESSION_DELAY = 1000;
export default function useQuizImpTrack(track, quizPromptModuleName, quizId) {
    const [isPromptImpressionTracked, setIsPromptImpressionTracked] = useState(false);
    const quizModalImpressionRef = useRef(null);
    const takeQuizClick = useCallback(() => {
        track.click({
            label: `${quizId} | ${quizPromptModuleName}-take-quiz`,
        });
    }, [track]);
    const goToTriviaClick = useCallback(() => {
        track.click({
            label: `${quizId} | ${quizPromptModuleName}-go-to-trivia`,
        });
    }, [track]);
    const quizModalImpression = useCallback(() => {
        if (quizModalImpressionRef && trackQuizModalImpression()) {
            track.impression({
                label: `${quizId} | ${quizPromptModuleName}-modal`,
            });
        }
    }, [track]);
    const quizPromptImpression = useCallback((onScreen) => {
        if (onScreen && !isPromptImpressionTracked) {
            const timeoutId = setTimeout(() => {
                track.impression({
                    label: `${quizId} | ${quizPromptModuleName}-prompt`,
                });
                setIsPromptImpressionTracked(true);
            }, IMPRESSION_DELAY);
            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [quizId, isPromptImpressionTracked]);
    return [quizPromptImpression, quizModalImpression, takeQuizClick, goToTriviaClick];
}
